import { Button, Image, Box } from '@chakra-ui/react';
import React from 'react';
import useModelButtonNotificacao from './useModelButtonNotificacao';

import { BellIcon } from '@chakra-ui/icons';
import ModalNotificacao from './ModalNotificacao/ModalNotificacao';
import '../Main/main.css';
function ButtonNotificacao() {
  const { modalNotificacaoHome, hiddenButton, cacheNotificacao, fetchData } = useModelButtonNotificacao();
  
  return (
    <>
      <ModalNotificacao disclosure={modalNotificacaoHome} cacheNotificacao={cacheNotificacao} refetch={fetchData}/>
      <Button
        hidden={hiddenButton}
        className=""
        position="fixed"
        top="100px"
        right="20px"
        zIndex="999"
        borderRadius="full"
        onClick={() => modalNotificacaoHome.onOpen()}
        display="flex"
        alignItems="center"
        justifyContent="center"
        p={0}
        bg={'transparent'}
      >
        <BellIcon position={'relative'} color={'#FFFFFF'} boxSize="1.8em"  />

        {/* <BellIcon position={'relative'} color={'red.500'} boxSize="1.5em"  /> */}
        {cacheNotificacao.length > 0 && 
          <Box
            className='small-pulse'
            position="absolute"
            bottom={1}
            right={1}
            bg="red"
            color="white"
            fontSize="8px" // Ajustado para ser legível
            fontWeight="bold"
            borderRadius="full"
            display="flex"
            alignItems="center"
            justifyContent="center"
            boxSize={4} // Define largura e altura como 4 (16px) simultaneamente
            lineHeight={0}
            p={0}
            >
            {cacheNotificacao.length > 99 ? '+99' : cacheNotificacao.length}
          </Box>
        }
      </Button>
    </>
  );
}

export default ButtonNotificacao;
